import React from "react";
import "./ServiceRow.css";

function ServiceRow({ id, icon, title, children, serviceKey }) {
  const goToAppointment = () => {
    // 1. затвори modal
    window.dispatchEvent(
      new CustomEvent("closeServiceModal")
    );

    // 2. скрол до appointment
    const section = document.getElementById("appointment");

    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }

    // 3. пополнување услуга
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent("prefillAppointment", {
          detail: serviceKey || title,
        })
      );
    }, 400);
  };

  return (
    <section id={id} className="service-modern">
      <div className="service-header">
        <div className="service-icon">{icon}</div>
        <h2>{title}</h2>
      </div>

      <div className="service-content">
        {children}
      </div>

      <div className="service-cta">
        <p>Брзо, сигурно и усогласено со закон.</p>
        <button onClick={goToAppointment}>
          Закажи преглед
        </button>
      </div>
    </section>
  );
}

export default ServiceRow;